/**
 * SnowIcon — sanitized from `assets/newSvg/snow.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function SnowIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M20.989,12.4463 C20.7564,17.2095 16.8208,21 11.9999,21 C10.5192,21 9.12198,20.6422 7.8899,20.0086 C8.7531,19.721 9.69133,19.3449 10.7019,18.88 C11.9437,18.3088 13.2947,17.6035 14.7498,16.7634 C16.2053,15.923 17.492,15.1055 18.6078,14.3155 C19.5147,13.6734 20.3088,13.0494 20.989,12.4463 Z M11.9999,3 C14.2254,3 16.2622,3.80776 17.8332,5.14608 L18.1502,5.07445942 C18.204873,5.06273798 18.2603992,5.05118132 18.3166791,5.0398751 L18.6626031,4.97572864 L18.6626031,4.97572864 L19.021825,4.92170531 C20.2967875,4.75513687 21.728125,4.850145 22.3921,6.00015 C23.1541,7.31994429 22.3337898,8.7836798 21.4354866,9.86238324 L21.2101565,10.1237315 L21.2101565,10.1237315 L20.9868,10.3672 L20.9868,10.3672 C19.5926,11.8453 17.2842,13.568 13.9998,15.4643 C10.7155,17.3605 8.06939,18.4983 6.09215,18.9666 L5.93321349,19.0031222 L5.93321349,19.0031222 L5.60193321,19.0716478 L5.60193321,19.0716478 L5.25627895,19.1311438 C3.9090912,19.337298 2.33771536,19.2649536 1.60749,18.0002 C0.94369125,16.85045 1.57666313,15.563675 2.35805977,14.5429766 L2.58436273,14.2589368 C2.62242236,14.2129196 2.66057056,14.1675929 2.69868332,14.123 L2.92594278,13.8645982 L2.92594278,13.8645982 L3.1464,13.6259 L3.1464,13.6259 C3.05014,13.0984 2.99983,12.5545 2.99983,12 C2.99983,7.02944 7.02935,3 11.9999,3 Z M3.87139,15.8685 L3.71722759,16.0818901 C3.55155664,16.3168457 3.37024174,16.6072235 3.34321771,16.8695568 L3.34335,16.998 C3.483525,17.247675 3.97979063,17.2504125 4.34516813,17.2230984 L4.64888,17.1938 L4.64888,17.1938 C4.35374,16.7768 4.09319,16.3337 3.87139,15.8685 Z M20.6563,7.00239 C20.4535667,6.85171 20.1231,6.83836333 19.8222926,6.85677667 L19.537201,6.88186654 C19.4932765,6.88650926 19.4516333,6.89105667 19.413,6.89502 C19.703,7.31529 19.9581,7.76144 20.1743,8.22928 L20.3354905,8.00413896 C20.5236012,7.7311708 20.7549917,7.34197078 20.6923379,7.08178418 L20.6601,7.00017 L20.6563,7.00239 Z"
        fill={color}
      />
    </Svg>
  );
}

export default SnowIcon;
